export default __webpack_public_path__ + "static/media/DuncanMcCue.040f68b8.png";